module.exports = __webpack_public_path__ + "static/media/ftg2.91d42c0c.jpg";